export default {
    maptiler :{
        url : 'https://api.maptiler.com/maps/basic/256/{z}/{x}/{y}.png?key=dLvghmKXztbrPhSiCC9k',
        attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
    }
}